@if (appReady) {
	<engagement-navbar></engagement-navbar>
}

<router-outlet></router-outlet>

@if (appReady) {
	<engagement-footer></engagement-footer>
}
